export default "__VITE_ASSET__DR7PXTPm__"